import { render, staticRenderFns } from "./knowledge.vue?vue&type=template&id=71eaff28&scoped=true"
import script from "./knowledge.vue?vue&type=script&lang=js"
export * from "./knowledge.vue?vue&type=script&lang=js"
import style0 from "./knowledge.vue?vue&type=style&index=0&id=71eaff28&prod&lang=scss"
import style1 from "./knowledge.vue?vue&type=style&index=1&id=71eaff28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eaff28",
  null
  
)

export default component.exports